import server from "./server";

export const getCategoriesApi = async () => {
  const response = await server().get("/categories");
  return response.data;
};

export const getSingleCategoryApi = async ({ slug }) => {
  const response = await server().get(`/categories/slug/${slug}`);
  return response.data;
};

export const getSingleCategoryByIdApi = async ({ id }) => {
  const response = await server().get(`/categories/${id}`);
  return response.data;
};

export const createCategoryApi = async ({ data }) => {
  const response = await server().post("/categories", data);
  return response.data;
};

export const updateCategoryApi = async ({ id, data }) => {
  const response = await server().put(`/categories/${id}`, data);
  return response.data;
};

export const deleteCategoryApi = async ({ id }) => {
  const response = await server().delete(`/categories/${id}`);
  return response.data;
};
